
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import ForAttorneys from "../pages/for-attorneys/page";
import PrivacyPolicy from "../pages/privacy-policy/page";
import TermsOfService from "../pages/terms-of-service/page";
import AIGovernance from "../pages/ai-governance/page";
import CommercialStrategy from "../pages/commercial-strategy/page";
import CorporateLaw from "../pages/corporate-law/page";
import StrategicPlanning from "../pages/strategic-planning/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/for-attorneys",
    element: <ForAttorneys />,
  },
  {
    path: "/ai-governance",
    element: <AIGovernance />,
  },
  {
    path: "/commercial-strategy",
    element: <CommercialStrategy />,
  },
  {
    path: "/corporate-law",
    element: <CorporateLaw />,
  },
  {
    path: "/strategic-planning",
    element: <StrategicPlanning />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/terms-of-service",
    element: <TermsOfService />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
